var path = 'areas/projects/views/group_editor.html';
var html = "<form ng-submit=save()> <div class=form-body> <error-box error=isSaving.error></error-box> <control-group label=Name> <input id=input-name class=form-control type=text ng-model=projectGroup.Name> </control-group> <control-group label=Description> <textarea id=input-desc ng-model=projectGroup.Description class=form-control markitup rows=7></textarea> </control-group> <last-modified model=projectGroup></last-modified> </div> <div class=form-actions> <button class=\"btn btn-success\" type=submit ng-disabled=isSaving.busy>Save</button> <spin active=isSaving.busy class=spin-static></spin> </div> </form> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/group_editor.html
// module id = 1438474189536867
// module chunks = 1